import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div style={{
      ...s.nav,
      ...(scrolled ? s.navScrolled : s.navTop)
    }}>

      {/* LEFT */}
      <div style={s.logoWrap}>
        <img src="/logo-blue.png" alt="logo" style={s.logoImg} />
        <span style={s.logoText}>DataSphere</span>
      </div>

      {/* CENTER */}
      <div style={s.center}>
        <a href="#features" style={s.centerLink}>Features</a>
        <a href="#how" style={s.centerLink}>How it works</a>
        <a href="#contact" style={s.centerLink}>Contact</a>
      </div>

      {/* RIGHT */}
      <div style={s.right}>
        <Link to="/login" style={s.link}>Sign in</Link>
        <Link to="/register" style={s.cta}>Get Started</Link>
      </div>

    </div>
  );
}
const s = {
  nav: {
    position: 'fixed', // key change
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 80px',
    transition: 'all 0.3s ease',
  },

  /* TOP (hero state) */
  navTop: {
    background: 'transparent',
    borderBottom: 'none',
  },

  /* SCROLLED STATE */
  navScrolled: {
    background: 'rgba(255,255,255,0.75)',
    backdropFilter: 'blur(14px)',
    borderBottom: '1px solid rgba(0,0,0,0.06)',
    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
  },

  /* LOGO */
  logoWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginLeft: 19,
  },

  logoImg: {
    width: 80,
    height: 28,
    objectFit: 'contain',
  },

  logoText: {
    fontWeight: 800,
    fontSize: 18,
    color: '#2545FC',
  },

  /* CENTER */
  center: {
    display: 'flex',
    gap: 30,
    alignItems: 'center',
  },

  centerLink: {
    textDecoration: 'none',
    color: 'rgba(0,0,0,0.7)',
    fontWeight: 500,
    fontSize: 14,
  },

  /* RIGHT */
  right: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },

  link: {
    textDecoration: 'none',
    color: 'rgba(0,0,0,0.7)',
    fontWeight: 500,
  },

  cta: {
    padding: '10px 16px',
    borderRadius: 10,
    background: 'linear-gradient(135deg,#4f46e5,#6366f1)',
    color: '#fff',
    textDecoration: 'none',
    fontWeight: 600,
    boxShadow: '0 6px 20px rgba(79,70,229,0.25)',
  },
};